import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetRespondentSpocsRPC } from "./getRespondentSpocsRPC";

export class GetRespondentSpocsRPCClientImpl extends GetRespondentSpocsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetRespondentSpocsRPC.Request): Promise<LeoRPCResult<GetRespondentSpocsRPC.Response, GetRespondentSpocsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "spoc-management/GetRespondentSpocs",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetRespondentSpocsRPC.ResponseDTO,
      GetRespondentSpocsRPC.Errors.ErrorsDTO,
      GetRespondentSpocsRPC.Response,
      GetRespondentSpocsRPC.Errors.Errors
    >(
      response,
      "spoc-management/GetRespondentSpocs",
      GetRespondentSpocsRPC.Response.fromDTO,
      GetRespondentSpocsRPC.Errors.fromDTO
    );
  }
}
